<template>
  <div
    class="d-flex justify-center align-center"
    id="header-cart"
    @click="reset"
  >
    <VicampoLink href="/checkout/cart" class="text-center">
      <Cart />
    </VicampoLink>
  </div>
</template>

<script>
import Cart from '@/components/basic/atoms/Cart.vue'
import { useCartStore } from '@/stores/cart'
import { mapActions } from 'pinia'
import { defineAsyncComponent } from 'vue'

const VicampoLink = defineAsyncComponent(
  () => import('@/components/basic/atoms/VicampoLink.vue')
)

export default {
  components: { Cart, VicampoLink },
  methods: {
    ...mapActions(useCartStore, ['reset'])
  }
}
</script>
